module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-5.66b22285.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-5.png
// module id = 195
// module chunks = 0